export enum UserRolesEnum {
    Admin = 'Administrator',
    Basic = 'Basic'    
}